import React, { PropsWithChildren } from 'react';

import './index.scss';

/**
 * Card mobile dos painéis de Observado/Previsão de uma sigla (header claro accent
 * + slot opcional de ação à direita + corpo). Fonte única de estilo para os painéis
 * de Status no mobile. Ver NAV_HIERARCHY.md ("Cabeçalho de card").
 */
export default function StatusCard({
  title,
  action,
  children,
}: PropsWithChildren<{ title: string; action?: React.ReactNode }>) {
  return (
    <section className="status-card-mobile">
      <header className="scm-header">
        <span className="scm-title">{title}</span>
        {action}
      </header>
      <div className="scm-body">{children}</div>
    </section>
  );
}
